export function isEmail(email){
    if(email.trim()==='')
        return true;
    return email.includes("@");
}

export function isEmpty(val){

    if(!val)
    {
        return true;
    }
    return val.trim()==='';
}